import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SocialSharingUtilsService {
  getTwitterUrl(text: string, url: string): string {
    let urlString = 'https://x.com/intent/tweet?';

    if (text) {
      urlString += `text=${encodeURIComponent(text)}`;
    }

    urlString += `&url=${encodeURIComponent(url)}`;

    return urlString;
  }

  getLinkedInUrl(text: string, url: string): string {
    let urlString = 'https://www.linkedin.com/shareArticle?mini=true';

    urlString += `&url=${encodeURIComponent(url)}`;

    if (text) {
      urlString += `&title=${encodeURIComponent(text)}`;
    }

    return urlString;
  }

  openSocialPopup(url: string): void {
    const popupWidth = 500;
    const popupHeight = 400;
    const windowFeatures = `toolbar=0,status=0,resizable=yes,width=${popupWidth},height=${popupHeight},`
      + `top=${(window.innerHeight - popupHeight) / 2},left=${(window.innerWidth - popupWidth) / 2}`;

    window.open(url, '_blank', windowFeatures);
  }
}
